import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialCurrentWorkflowItemState } from '../initialState';
import { WorkflowItem } from '../interfaces';

/* 
NOTE: we will be using the following naming conventions for defineing actions

1. in case of the whole object being changed: it should start as a SETTER i.e., setBasicDetails
2. in case of a particular key being updated in the object: it should start as an UPDATE function i.e., updateUserSessionActive
*/

export const currentWorkflowItemSlice = createSlice({
  name: 'currentWorkflowItem',
  initialState: initialCurrentWorkflowItemState,
  reducers: {
    setCurrentWorkflowItem: (state, action: PayloadAction<WorkflowItem>): WorkflowItem => {
      return { ...state, ...action.payload };
    },
  },
});

export const firstWorkflowItemSlice = createSlice({
  name: 'firstWorkflowItem',
  initialState: initialCurrentWorkflowItemState,
  reducers: {
    setFirstWorkflowItem: (state, action: PayloadAction<WorkflowItem>): WorkflowItem => {
      return { ...state, ...action.payload };
    },
  },
});

export default currentWorkflowItemSlice.reducer;
